import { j as jsxRuntimeExports } from './jsx-runtime-D2XkDcqR.js';
import * as require$$0 from 'react';

const MetaPixelTracking = ({ id, ...config }) => {
  require$$0.useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src = getScriptSrc();
    document.head.appendChild(script);
    return () => {
      script.remove();
    };
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "script",
    {
      dangerouslySetInnerHTML: {
        __html: getScriptInit(id, config)
      }
    }
  );
};
const getScriptSrc = () => "https://connect.facebook.net/en_US/fbevents.js";
const getScriptInit = (id, config) => [
  `fbq=_fbq=(...e)=>{fbq.callMethod?fbq.callMethod(...e):fbq.queue.push(e)}`,
  `fbq.loaded=!0`,
  `fbq.version="2.0"`,
  `fbq.queue=[]`,
  `fbq("init",${JSON.stringify(id)})`,
  `fbq("track","PageView",${JSON.stringify(config)})`
].join(";");

export { MetaPixelTracking };
